import { render, staticRenderFns } from "./fangzhuan.vue?vue&type=template&id=353a02ca&"
import script from "./fangzhuan.vue?vue&type=script&lang=js&"
export * from "./fangzhuan.vue?vue&type=script&lang=js&"
import style0 from "./fangzhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports